<template>
  <div
    v-if="fab_detail.is_show === 1 && delay_show"
    class="float-btn"
    :style="{
      right: right + 'px',
      bottom: bottom + 'px',
    }"
    ref="div"
    @touchstart="
      (e) => {
        dragStart(e);
      }
    "
    @touchend="
      (e) => {
        dragEnd(e);
      }
    "
    @touchmove.prevent="
      (e) => {
        dragProgress(e);
      }
    "
  >
    <img v-if="fab_detail.url" @click="toFloatDetail" :src="fab_detail.url" />
  </div>
</template>
<script>
import { encodeSearchParams } from "@/utils/tools";
import api from "@/apis/maintenance-api";
export default {
  props: {
    padding_right: {
      type: Number,
      default: 0,
    },
    padding_bottom: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timer: false,
      clientWidth: 0, //设备宽度
      clientHeight: 0, //设备高度
      right: document.documentElement.style.fontSize.split("px")[0] * 0.17,
      bottom: document.documentElement.style.fontSize.split("px")[0] * 0.65,
      itemWidth: document.documentElement.style.fontSize.split("px")[0] * 1.28, // 图标的宽度
      itemHeight: document.documentElement.style.fontSize.split("px")[0] * 1.28, // 图标的高度
      fab_detail: {}, //悬浮窗信息
      extra_params: "", //跳转安心保额外参数
      delay_show: false,
    };
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
  },
  mounted() {
    if (this.padding_bottom) {
      this.bottom =
        document.documentElement.style.fontSize.split("px")[0] *
        this.padding_bottom;
    }
    // this.right =
    //   document.documentElement.style.fontSize.split("px")[0] *
    //   this.padding_right;
    console.log(23322);
    this.fetchFabDetail(); //获取浮窗详情（图片、是否显示）
  },
  destroyed() {
    this.timer && clearTimeout(this.timer);
  },
  methods: {
    /**
     * 拖动开始
     */
    dragStart() {
      this.$refs.div.style.transition = "none";
    },
    /**
     * 拖动结束
     */
    dragEnd() {
      this.$refs.div.style.transition = "all 0.3s";
      if (this.right + this.itemWidth / 2 <= this.clientWidth / 2) {
        this.right = 10;
      } else {
        this.right = this.clientWidth - 10 - this.itemWidth;
      }
      if (this.bottom > this.clientHeight - this.itemHeight - 10) {
        this.bottom = this.clientHeight - 10 - this.itemHeight;
      } else if (this.bottom <= 10) {
        this.bottom = 10;
      }
    },
    /**
     * 拖动过程中更新位置
     * @param {Object} e
     */
    dragProgress(e) {
      if (e.targetTouches.length === 1) {
        let touch = e.targetTouches[0];
        this.right = this.clientWidth - touch.clientX - this.itemWidth / 2;
        this.bottom = this.clientHeight - touch.clientY - this.itemHeight / 2;
      }
    },
    /**
     * 获取悬浮窗详情
     * @author 田月荣 <tianyuerong@vchangyi.com>
     */
    async fetchFabDetail() {
      this.$loading.show("加载中...");
      const params = {
        uuid: window.localStorage.getItem("OILUSER"),
        scheme_hash: this.$route.query.scheme_id || this.$route.query.id,
      };
      try {
        const res = await api.getFabDetailApi(params);
        this.$loading.hide();
        if (res.code === 0) {
          this.fab_detail = res.data;
          // 延迟显示：修复因为transition导致的初始位置异常
          // this.timer = setTimeout(() => {
          this.delay_show = true;
          // }, 900);
        } else {
          this.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    /**
     * 点击悬浮窗埋点
     */
    async clickFabTracking() {
      const params = {
        uuid: window.localStorage.getItem("OILUSER"),
        exposure_id: this.fab_detail.exposure_id,
      };
      try {
        const res = await api.clickFabTrackingApi(params);
        if (res.code !== 0) {
          console.log("点击悬浮窗埋点异常-response", res);
        }
      } catch (error) {
        console.log("点击悬浮窗埋点失败-error", error);
      }
    },
    /**
     * 点击悬浮窗跳转
     */
    async toFloatDetail() {
      await this.clickFabTracking(); //点击悬浮窗埋点
      // jump_type	int	跳转模块:0-不跳转，1-小程序，2-H5页面，3-其他小程序
      if (this.fab_detail.jump_type === 2) {
        this.handleBeforeJump(this.fab_detail.jump_value); //跳转前的数据处理
      }
    },
    /**
     * 跳转H5前的数据处理
     */
    async handleBeforeJump(jump_value) {
      if (jump_value.indexOf("insurance-introduction") === -1) {
        window.location.href = jump_value;
      } else {
        await this.fetchExtraParams();
        if (!this.extra_params) {
          this.$toast.show({
            showTime: 2,
            message: "参数异常",
            style: "error",
          });
          return;
        }
        window.location.href = jump_value + "?" + this.extra_params;
      }
    },
    /**
     * 获取安心保落地页所需参数
     */
    async fetchExtraParams() {
      try {
        const res = await api.getLandingExtraParamsApi({
          uuid: localStorage.getItem("OILUSER"),
          hash: this.$route.query.scheme_id || this.$route.query.id,
        });
        if (res.code === 0) {
          this.extra_params = encodeSearchParams(res.data);
        } else {
          console.log("获取安心保落地页所需参数异常-response", res);
        }
      } catch (error) {
        console.log("获取安心保落地页所需参数失败", error);
      }
    },
  },
};
</script>
<style lang="less">
.float-btn {
  color: #666;
  z-index: 10;
  transition: all 0.3s;
  position: fixed;
  right: 17/100rem;
  bottom: 65/100rem;
  white-space: nowrap;
  width: 128/100rem;
  height: 128/100rem;
  img {
    width: 128/100rem;
    height: 128/100rem;
    filter: drop-shadow(0px 2/100rem 12/100rem rgba(0, 0, 0, 0.15));
  }
}
</style>
